import { initCurrencyData } from "../../../constants/initCurrencyData";

const cloudPaymentsPayAsGoText = (credits) => `Единоразовое приобретение - ${credits} кредитов`

const cloudPaymentsSubscriptionText = (credits, isAnnuallyOn) => `Подписка на bgrem.ai - ${credits} кредитов в месяц (${isAnnuallyOn ? "ежегодное списание" : "ежемесячное списание"})`


const cloudPaymentsThreeMonthSubscriptionText = (credits) => `Подписка на bgrem.ai - ${credits} кредитов раз в 3 месяца`

const cloudPaymentsDefaultData = {
  currency: "RUB", //валюта
  skin: "mini", //дизайн виджета (необязательно)
  autoClose: 3, //время в секундах до авто-закрытия виджета (необязательный)
}

export { cloudPaymentsPayAsGoText, cloudPaymentsSubscriptionText, cloudPaymentsDefaultData, cloudPaymentsThreeMonthSubscriptionText, initCurrencyData }